import { useState, useEffect, Dispatch, SetStateAction } from "react";
import styles from "./CartDrawer.module.css";
import { CartConfigInterface } from "../CartTypes";
import CloseIcon from "../CartIcons/CloseIcon";
const ErrorBox = ({
    errors,
    setErrors,
    cartConfig,
}: {
    cartConfig: CartConfigInterface;
    errors: null | { isError: boolean; msg: string };
    setErrors: Dispatch<SetStateAction<null | { isError: boolean; msg: string }>>;
}) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
        const timer = setTimeout(() => {
            setVisible(false);
            setErrors(null);
        }, 3000); // Hide after 3 seconds

        return () => clearTimeout(timer);
    }, [errors?.msg]);

    return errors !== null ? (
        <div
            className={`${styles.msgContainerWrapper} ${errors?.isError && styles.error} ${
                visible ? styles.show : styles.hide
            }`}
            style={{
                fontFamily: cartConfig?.cart_design?.cart_font_family,
            }}
        >
            <span className={styles.msgContainer}>
                <span style={{ display: "flex", flexGrow: 1 }}>{errors?.msg}</span>
                <span
                    className={styles.closeIcon}
                    onClick={(e: any) => {
                        e?.preventDefault();
                        e?.stopPropagation();
                        setErrors(null);
                    }}
                >
                    <CloseIcon />
                </span>
            </span>
        </div>
    ) : (
        <></>
    );
};

export default ErrorBox;
